import React from 'react'
import { Row, Col, Form, Input, DatePicker, notification } from 'antd'
import { withApollo } from 'react-apollo'
import moment from 'moment'

import {
    ADD_USER,
    GET_PAGINATED_USER_TOPICS
} from '../../qql'

import './AddParticipant.scss'

class AddParticipant extends React.Component {
    constructor(props) {
        super(props)

        this.state={
            error_entry: null
        }

        this.formRef = React.createRef()

    }

    onSubmit = () => {
        this.formRef.current.submit()
    }

    onAddUser = (variables) => {
        const { client } = this.props

        client.mutate({
            mutation: ADD_USER,
            variables,
            // refetchQueries: this.userTopicsRefetcher()
            refetchQueries: [{
                query: GET_PAGINATED_USER_TOPICS,
                variables: {
                  page: this.props.page,
                  pageSize: this.props.page_size
                }
            }]
        }).then(res => {

            if(res.data.addUser) {
                notification.success({
                    message: "Attendee successfully added"
                })
            
                this.props.showAddAttendeeSetter(false)
                this.resetFormFields()
            } else {
                this.setState({
                    error_entry: 'Entry already existing'
                })
            }
        })
    }

    userTopicsRefetcher = () => {
        const { tableData } = this.props
        const toRefetch = []

        if(tableData) {
            const { getUserTopics } = tableData
            const { pagination } = getUserTopics
            const count = pagination.pageCount + 1

            for (var i = 0; i < count; i++) {
                toRefetch.push({
                    query: GET_PAGINATED_USER_TOPICS,
                    variables:{
                      page: i + 1,
                      pageSize: 10,
                      filter: {
                        search: ''
                      }
                    }
                })
            }

        }

        return toRefetch
    }

    resetFormFields = () => {
        this.formRef.current.resetFields()
        this.setState({
            error_entry: null
        })
    }

    validateFullname = (rule, value, callback) => {
        if(value &&  value.trim() === '') {
            return callback("Please enter your fullname")
        }
    
        callback()
    }

    validateTopic = (rule, value, callback) => {
        if(value &&  value.trim() === '') {
            return callback("Please enter topic")
        }
    
        callback()
    }
    
    render() {
        return (
            <div className="add-participant__container">
                <Form 
                    hideRequiredMark
                    labelCol={{
                        span: 7
                    }}
                    labelAlign="left"
                    colon={false}
                    onFinish={e => {
                        this.onAddUser({
                            fullname: e.fullname, 
                            email: e.email_address, 
                            date_attended: e.date_attended, 
                            topic: e.topic
                        })
                    }}
                    onFinishFailed={e => {
                        // console.log("FAILED: ", e)
                    }}
                    ref={this.formRef}
                    onFieldsChange={e => {
                        this.setState({
                            error_entry: null
                        })
                    }}
                >
                    <Form.Item
                        label={<div className="add-participant__label">Full Name</div>}
                        name='fullname'
                        rules={[
                            { required: true, message: 'Please enter full name' },
                            { validator: this.validateFullname }
                        ]}
                    >
                        <Input
                            placeholder="Please input full name here"
                        />
                    </Form.Item>
                    <Form.Item
                        label={<div className="add-participant__label">Email Address</div>}
                        name='email_address'
                        rules={[
                            { required: true, message: 'Please enter email address' },
                            { type: 'email', message: 'Please enter a valid email address'}
                        ]}
                    >
                        <Input
                            placeholder="Please input email address here"
                        />
                    </Form.Item>
                    <Form.Item
                        label={<div className="add-participant__label">Date Attended</div>}
                        name="date_attended"
                        rules={[
                            { required: true, message: 'Please enter date attended' }
                        ]}
                    >
                        <DatePicker/>
                    </Form.Item>
                    <Form.Item
                        label={<div className="add-participant__label">Topic</div>}
                        name="topic"
                        rules={[
                            { required: true, message: 'Please enter topic' },
                            { validator: this.validateTopic }
                        ]}
                    >
                        <Input
                            placeholder="Please input topic name here"
                        />
                    </Form.Item>
                </Form>
                {this.state.error_entry? 
                    <div className="add-participant__error-div"> 
                        {this.state.error_entry}
                    </div>
                :null}
            </div>
        )
    }
    
}

export default withApollo(AddParticipant, { withRef: true })